import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import moment from "Helpers/MomentCompat";
import { showNotification } from "Helpers/Toast";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";

import SponsorOrderForm from "../SponsorOrderForm";
import * as S from "./styles";

const UpdateProjectSponsorOrdersz = ({
  projectId,
  sponsorOptions,
  getProjectById,
}) => {
  const { api } = UseServices();
  const { loading } = UseGlobalLoading();

  const [sponsorOrders, setSponsorOrders] = useState([]);
  const [selectedSponsorOrder, setSelectedSponsorOrder] = useState(null);

  useEffect(() => {
    if (projectId) {
      return getProjectSponsorOrders(projectId);
    }

    // eslint-disable-next-line
  }, [projectId]);

  const getProjectSponsorOrders = (project_id) => {
    api
      .post("/projects/get-project-sponsor-orders", {
        project_id: project_id,
      })
      .then((response) => {
        const sponsorOrders = response.data;

        setSponsorOrders(sponsorOrders);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const addSponsorToProject = (sponsor_id) => {
    api
      .post("/projects/add-sponsor-to-project", {
        project_id: projectId,
        sponsor_id,
      })
      .then(() => {
        showNotification(
          "success",
          "Sucesso!",
          "Patrocinador adicionado ao projeto com sucesso!",
        );

        getProjectSponsorOrders(projectId);
        getProjectById(projectId);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  return (
    <S.Wrapper>
      {selectedSponsorOrder ? (
        <SponsorOrderForm
          projectId={projectId}
          selectedSponsorOrder={selectedSponsorOrder}
          setSelectedSponsorOrder={setSelectedSponsorOrder}
          sponsorOptions={sponsorOptions}
          getProjectSponsorOrders={getProjectSponsorOrders}
        />
      ) : null}
      <Form>
        <S.Section>
          <span>Pedidos de Validação de Patrocínio</span>
          <hr />
        </S.Section>

        <S.Buttons>
          <div />

          <Button
            type="button"
            text="Criar Pedido"
            disabled={loading}
            onClick={() => setSelectedSponsorOrder(true)}
          />
        </S.Buttons>

        {!sponsorOrders.length ? <span>Nenhum pedido cadastrado.</span> : null}

        {sponsorOrders.map((order) => (
          <S.Counterpart key={order.id} id="order">
            <S.CounterpartInfos>
              <h2>{order.sponsor?.full_name}</h2>
              <span>
                <strong>Status:</strong> {order.status}
              </span>
              {order.status === "Aprovado" && (
                <span>
                  Aprovado em:{" "}
                  <strong>
                    {moment(order.approved_at).format("DD/MM/YYYY HH:mm")}
                  </strong>
                </span>
              )}
              <p>
                <strong>Texto:</strong> {order.text}
              </p>

              {order.sponsor_is_in_project && (
                <strong>Patrocinador já cadastrado no projeto.</strong>
              )}

              <S.Buttons>
                <Button
                  type="button"
                  text="Editar"
                  disabled={loading}
                  onClick={() => setSelectedSponsorOrder(order)}
                />
                {order.status === "Aprovado" && !order.sponsor_is_in_project ? (
                  <Button
                    type="button"
                    variant="success"
                    text="Adicionar Patrocinador ao Projeto"
                    disabled={loading}
                    onClick={() => addSponsorToProject(order.sponsor?.id)}
                  />
                ) : null}
              </S.Buttons>
            </S.CounterpartInfos>
          </S.Counterpart>
        ))}
      </Form>
    </S.Wrapper>
  );
};

export default UpdateProjectSponsorOrdersz;
